
import { UserForm } from './UserForm';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../../components/Notifications';

export function UserCreate() {
  const navigate = useNavigate();
  const {addNotification} = useNotification();

  return (
    <UserForm
      onSuccess={() => {
        addNotification('User created successfully!', 'success');
        navigate('/users');
      }}
    />
  );
};
